<template>
    <div class="course_card" :style="{color: setColor(card.coverUrl), backgroundImage: setImage(card.coverUrl), backgroundColor: setBackgroundColor(card.coverUrl)}">
        <div class="course_card_top">
<!--            <img v-if="!showFile" class="course_finish" src="../../../assets/image/mango/classroom/finish-icon.png" alt="">-->
            <div class="course_card_title">{{card.title}}</div>
            <div class="course_card_info"><span v-if="card['className']">{{card.className}}&emsp;</span><span v-if="showStudent">{{card.studentNum}}名学生正在学习</span></div>
        </div>
        <div v-if="false" class="course_card_bottom">
            <div v-for="(file, index) in fileList" :key="index" class="course_card_file">
                <span v-show="!file.checked" class="point"></span>
                <div class="card_file">{{file.dateTime}} {{file.title}}</div>
            </div>
            <div v-if="!isLoading && !fileList.length" class="course_card_file_empty">
                <span></span>
                <span>暂无数据</span>
            </div>
        </div>
        <div slot="reference" class="operation_point" @mouseenter.stop="isOperationPanelShown = true" @click.stop="isOperationPanelShown = !isOperationPanelShown">
            <div v-for="i of [1, 2, 3]" :key="i" class="point" :style="{backgroundColor: card.coverUrl}"></div>
        </div>
        <div v-if="isOperationPanelShown && card.coverUrl" class="edit_popover" :class="{'edit_popover_wide': courseType === 2}">
            <p v-if="courseType === 1" @click.stop="markStatus(2)">标记为已完成</p>
            <p v-if="courseType === 2" @click.stop="markStatus(1)">标记为正在上的课</p>
            <p @click.stop="edit">编辑</p>
        </div>
        <div v-if="isOperationPanelShown && card.coverUrl" class="delete_popover" :class="{'edit_popover_wide': courseType === 2}">
            <p @click.stop="deleteCourse">删除</p>
        </div>
    </div>
</template>

<script>
    import subjectInfo from '../../../config/constant'
    import format from '../../../config/public/DateFormat'

    export default {
        name: "courseCard",
        data () {
            return {
                isLoading: false,
                fileList: [],
                isOperationPanelShown: false,
            }
        },
        props: {
            card: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            showStudent: {
                type: Boolean,
                default: false
            },
            courseType: {
                type: Number, // 1:正在上的课 2:已完成的课
            }
        },
        mounted() {
            document.addEventListener('click', () => {
                this.isOperationPanelShown = false;
            });
        },
        methods: {
            setColor (cardColor = null) {
                let color = '#FF9764';
                subjectInfo.subjectInfo.every(item => {
                    let id = Number(this.card.subjectId) || 50;
                    if (item.id === id) {
                        color = item.color;
                        return false
                    }
                    return true
                });

                return cardColor ? cardColor : color;
            },
            setImage (cardColor = null) {
                let img = subjectInfo.subjectInfo[subjectInfo.subjectInfo.length - 1].image;
                subjectInfo.subjectInfo.every(item => {
                    let id = Number(this.card.subjectId) || 50;
                    if (item.id === id) {
                        img = item.image;
                        return false
                    }
                    return true
                });

                return cardColor ? 'none' : `url(${img})`;
            },
            setBackgroundColor(cardColor) {
                return cardColor ? format.hexToRgba(cardColor, 0.05) : 'none';
            },
            getCardFile () {
                this.isLoading = true;
                this.fileList = [];
                this.$https.get(`/api/conn/coz/getCourseTips`, {
                    params: {
                        courseId: this.card.courseId
                    }
                }).then((response) => {
                    if (response.code === 0) {
                        let list = Object.values(response.data);
                        this.fileList = list.map(item => {
                            item.dateTime = this.$format.formatTime(item.date, 'MM-dd');
                            return item
                        });
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    this.isLoading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                })
            },
            edit() {
                this.$emit('edit', {courseId: this.card.courseId});
            },
            deleteCourse() {
                this.$emit('delete', {courseId: this.card.courseId});
            },
            markStatus(status) {
                this.$https('/api/conn/coz/teacher/updateCourseStatus', {
                    params: {
                        courseId: this.card.courseId,
                        status: status, //1:正在上 2:已完成
                    }
                }).then(response => {
                    if (response['code'] !== 0)
                        return;

                    this.$emit('statusChange');
                }).catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .course_card{
        position: relative;
        width: 276px;
        height: 160px;
        border-radius: 6px;
        /*background-image: url("../../../assets/image/mango/course/shu.png");*/
        background-size: 100% 100%;
        background-repeat: no-repeat;
        text-align: left;
        cursor: pointer;
        .course_card_top{
            padding: 32px 24px;
            height: 123px;
            box-sizing: border-box;
            position: relative;
            .course_finish{
                position: absolute;
                right: 20px;
                top: 0;
                width: 34px;
            }
            .course_card_title{
                font-size:16px;
                /*font-family:PingFangSC-Semibold,PingFang SC;*/
                /*font-weight:600;*/
                line-height:23px;
            }
            .course_card_info{
                margin-top: 5px;
                font-size:14px;
                /*font-family:PingFangSC-Regular,PingFang SC;*/
                font-weight:400;
                line-height:23px;
            }
        }
        .operation_point {
            position: absolute;
            top: 10px;
            right: 10px;

            .point {
                width: 5px;
                height: 5px;
                margin-bottom: 3px;
                border-radius: 5px;
            }
        }

        .edit_popover, .delete_popover {
            position: absolute;
            right: -87px;
            min-width: 90px;
            /*padding: 8px;*/
            padding-left: 8px;
            padding-right: 8px;
            background-color: #ffffff;
            box-shadow:2px 2px 6px 0px rgba(0,0,0,0.21);
            border-radius:8px;
            color: #6D7278;
            font-family: Alibaba-PuHuiTi-Regular;
            z-index: 10;

            & > p {
                margin: 0;
                padding-bottom: 4px;
                padding-top: 4px;
            }
        }
        .edit_popover {
            top: 33px;

            & > p:first-of-type {
                border-bottom: 1px solid #DCDCDC;
            }
        }
        .delete_popover {
            top: 100px;
        }
        .edit_popover_wide {
            width: 112px;
        }
    }
</style>
